<template>
    <div>
        <section v-if="paso1" class="padding-vertical-content white-content right-background">
            <div class="thumb-container absolute grayscale light-thumb" :style='"background-image: url(" + manager.bg2_url + ")"'></div>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row justify-content-start">
                            <div class="col-12 col-lg-6 col-xl-5">
                                <div v-if="loading">
                                    <LoaderComponent></LoaderComponent>
                                </div>
                                <h2 class="m-0 mt-5 h1 text-uppercase">{{ $t('renovar_abono.renueva_abono') }}</h2>
                                <div class="subtitle h3 light mb-3 mb-lg-5"> {{ $t('renovar_abono.temporada', { temporada: lista_abonados.nombre }) }}</div>

                                <BuscarAbonadoComponent :abonado="abonado_search" v-on:terminado="buscarAbonado" :n_abonado="n_abonado"></BuscarAbonadoComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="padding-vertical-content" v-if="abonado">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="h2 mb-3 mb-lg-4 d-block">{{ $t('renovar_abono.tus_datos') }}</div>
                        <div class="lightgray-content p-2 p-lg-3 w-100 mb-4">
                            <InformacionAbonadoComponent :abonado="abonado" :asiento="asiento"></InformacionAbonadoComponent>
                        </div>
                    </div>
                    <div class="col-12">
                        <div v-if="paso3">
                            <div class="h2 mb-3 mb-lg-4 d-block">{{ $t('renovar_abono.renovacion_abono') }}</div>
                            <div class="row flex-lg-nowrap">
                                <div class="col-12 col-lg-4" v-if="asiento">
                                    <label class="d-block h5"><span class="altcolor">A</span>. {{ $t('renovar_abono.asiento_anterior') }}</label>
                                    <div class="lightgray-content p-2 p-lg-3 mb-3">
                                        <ul class="info-list list-unstyled w-100">
                                            <li><label>{{ $t('renovar_abono.tipo') }}</label> {{ $t('renovar_abono.asiento_anterior') }}</li>
                                            <li><label>{{ $t('general.sector') }}:</label> {{ asiento.region_name }}</li>
                                            <li v-if="asiento.row"><label>{{ $t('general.fila') }}:</label> {{ asiento.row }}</li>
                                            <li v-if="asiento.seat"><label>{{ $t('general.butaca') }}:</label> {{ asiento.seat }}</li>
                                            <li>
                                                <label>{{ $t('renovar_abono.disponibilidad') }}:</label>
                                                <strong v-if="asiento.ocupado != 1 && asiento.region_disponible" class="green">{{ $t('mapa.disponible') }}</strong>
                                                <strong v-else class="text-danger">{{ $t('mapa.no_disponible') }}</strong>
                                            </li>
                                        </ul>

                                        <router-link
                                            v-if="asiento.ocupado != 1 && asiento.region_disponible"
                                            class="button effect-button"
                                            :to="{ name: 'front.abonos.nuevo.index', query: { region_id: asiento.region_id, seat: asiento.seat, row: asiento.row, dni: abonado.dni, n_abonado_antiguo: abonado.n_abonado_antiguo }}"
                                        >
                                            {{ $t('renovar_abono.renovar') }}
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-8" v-if="!puede_cambiar_butaca">
                                    <label class="d-block h5"><span class="altcolor">{{ $t('renovar_abono.no_cambio') }}</span></label>
                                </div>
                                <div class="col-12 col-lg-8" v-else>
                                    <label class="d-block h5"><span class="altcolor">B</span>. {{ $t('renovar_abono.nuevo_asiento') }}</label>
                                    <div class="lightgray-content p-2 p-lg-3 mb-3">
                                        <template v-if="recinto.svg_teatros">
                                            <SvgComponent 
                                                :zonas="zonas" 
                                                :place="recinto" 
                                                @clickZona="cambiarZona"
                                            ></SvgComponent>
                                        </template>
                                        <template v-else>
                                            <MapaSvgComponent
                                                :zonas="zonas"
                                                :can_click="true"
                                                :popup_enabled="true"
                                                :occupied="false"
                                                @clickZona="cambiarZona"
                                            ></MapaSvgComponent>
                                        </template>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template v-else>
                            <div style="height: 100px">
                                <LoaderComponent></LoaderComponent>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </section>
        <section class="padding-vertical-content" v-if="error">
            <div class="container">
                <div class="row">
                    <div class="col-12" v-if="error == 300">
                        <h1>{{ $t('renovar_abono.ya renovado') }}</h1>
                    </div>
                    <div class="col-12" v-else>

                        <h1>{{ $t('renovar_abono.no_existe') }}</h1>
                        <div v-if="configuracion.mensaje_renovacion" v-html="configuracion.mensaje_renovacion"></div>
                        <div v-else style="margin: 20px">
                          {{ $t('renovar_abono.escriba_correo', { email: this.footer.email_incidencias }) }}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import BuscarAbonadoComponent from '@/components/frontend/abonos/renovar/BuscarAbonadoComponent';
    import InformacionAbonadoComponent from '@/components/frontend/abonos/renovar/InformacionAbonadoComponent';
    import MapaSvgComponent from '@/components/frontend/abonos/renovar/MapaSvgComponent';
    import SvgComponent from '@/components/svg/SvgComponent';

    export default {
        props: [],
        data() {
            return {
                paso1: true,
                paso2: false,
                paso3: false,
                abonado_search: {
                    dni: null,
                    n_abonado_antiguo: null
                },
                abonado: null,
                asiento: null,
                precio_renovacion: 0,
                error: false,
                loading: false,
                renovacion: false,
                puede_cambiar_butaca: false
            }
        },
        created() {
            if(this.$route.query.n_abonado_antiguo && this.$route.query.dni) {
                this.abonado_search.dni = this.$route.query.dni;
                this.abonado_search.n_abonado_antiguo = this.$route.query.n_abonado_antiguo;
                this.buscarAbonado();
                this.renovacion = true;
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
              return this.$store.getters.getFooter;
            },
            n_abonado() {
                if(
                    this.configuracion.hash_teatro == '8dNXTskYUgIlv2DKgYcr' 
                    || this.configuracion.hash_teatro == '6nfDGSpJnBAZOAPNff2f'
                    || this.configuracion.hash_teatro == 'KbG3Jc0gLsXpVHncS9P6'
                    || this.configuracion.hash_teatro == 'aUqgiYN4suZEJDbHJujV'
                ) {
                    return false;
                } else {
                    return true;
                }
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            }
        },
        methods: {
            getZonas() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        renovacion: true
                    },
                    tid: this.configuracion.hash_teatro,
                    renovacion: true
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.index'), params).then(res => {
                    this.zonas = res.data.data;
                    this.paso3 = true;
                }).finally(() => this.loading = false);
            },
            buscarAbonado() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: this.abonado_search.dni,
                        n_abonado_antiguo: this.abonado_search.n_abonado_antiguo
                    },
                    tid: this.configuracion.hash_teatro,
                    dni: this.abonado_search.dni,
                    n_abonado_antiguo: this.abonado_search.n_abonado_antiguo
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar'), params).then(res => {
                    this.abonado = res.data.abonado;
                    this.precio_renovacion = res.data.recio_renovacion;
                    this.puede_cambiar_butaca = res.data.puede_cambiar_butaca;
                    this.asiento = res.data.asiento;
                    if(!this.abonado) {
                        this.error = res.data.message;
                    } else {
                        this.error = false;
                    }
                    this.getZonas();
                    this.loading = false;
                    this.paso2 = true;
                }).catch(error => {
                    this.error = error.response.status;
                    this.loading = false;
                });
            },
            cambiarZona(zona) {
                this.$router.push({ name: 'front.abonos.nuevo.index', query: { region_id: zona.id, dni: this.abonado.dni, n_abonado_antiguo: this.abonado.n_abonado_antiguo }});
            }
        },
        components: {
            BuscarAbonadoComponent, InformacionAbonadoComponent, MapaSvgComponent, SvgComponent
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
